<template>
  <div class="vx-row match-height">
    <div class="flex-col w-full">
      <div class="vx-col w-full mb-5">
        <router-link
          :to="{ path: '/ProcurementManagement/CreatePurchaseRequest' }"
          class="vs-component vs-button bg_l_green vx-col"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />{{
            $t("CreatePurchaseRequest")
          }}
        </router-link>
      </div>
      <vx-card class="mt-2">
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('Draft')">
            <draft></draft>
          </vs-tab>
          <vs-tab :label="$t('ReviewQueue')">
            <ReviewQueue></ReviewQueue>
          </vs-tab>
          <vs-tab :label="$t('Confirmed')">
            <confirm></confirm>
          </vs-tab>
          <vs-tab :label="$t('InProcess')">
            <proccessing></proccessing>
          </vs-tab>
          <vs-tab :label="$t('Sent')">
            <sent></sent>
          </vs-tab>
          <vs-tab :label="$t('Delivered')">
            <delivered></delivered>
          </vs-tab>
          <vs-tab :label="$t('IgnoredOrders')">
            <ignoredOrders></ignoredOrders>
          </vs-tab>
          <vs-tab :label="$t('AllPurchaseRequest')">
            <allPurchaseRequests></allPurchaseRequests>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import draft from "./DraftPurchaseRequest.vue";
import ReviewQueue from "./ReviewQueue.vue";
import confirm from "./Confirm.vue";
import proccessing from "./Processing.vue";
import sent from "./Sent.vue";
import delivered from "./Delivered.vue";
import ignoredOrders from "./IgnoredOrders.vue";
import allPurchaseRequests from "./AllPurchaseRequests.vue";
export default {
  components: {
    draft,
    confirm,
    proccessing,
    sent,
    delivered,
    ignoredOrders,
    allPurchaseRequests,
    ReviewQueue
  },
};
</script>
